import { Component, input, afterNextRender } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import Swiper from 'swiper';
import { Autoplay, FreeMode } from 'swiper/modules';

export interface LogoImage {
  id: number;
  src: string;
  width: number;
  height: number;
  alt: string;
}

export interface LogoCarouselConfig {
  speed?: number;
  slidesPerView?: number;
  breakpoints?: {
    tablet?: number;
    desktop?: number;
    large?: number;
  };
  autoplay?: {
    delay?: number;
    disableOnInteraction?: boolean;
    pauseOnMouseEnter?: boolean;
  };
}

@Component({
  selector: 'app-logo-carousel',
  imports: [NgOptimizedImage],
  templateUrl: './logo-carousel.component.html',
  styleUrl: './logo-carousel.component.scss'
})
export class LogoCarouselComponent {
  images = input.required<LogoImage[]>();
  config = input<LogoCarouselConfig>({
    speed: 4200,
    slidesPerView: 2,
    breakpoints: {
      tablet: 3,
      desktop: 4,
      large: 5
    },
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: false
    }
  });

  uniqueId = `logo-carousel-${Math.random().toString(36).substring(2, 9)}`;

  constructor() {
    afterNextRender(() => {
      this.initializeSwiper();
    });
  }

  private initializeSwiper(): void {
    const configuration = this.config();

    try {
      new Swiper(`.${this.uniqueId}`, {
        modules: [Autoplay, FreeMode],
        speed: configuration.speed,
        direction: 'horizontal',
        autoplay: configuration.autoplay,
        loop: true,
        slidesPerView: configuration.slidesPerView,
        freeMode: true,
        grabCursor: true,
        breakpoints: {
          720: {
            slidesPerView: configuration.breakpoints?.tablet || 3,
          },
          961: {
            slidesPerView: configuration.breakpoints?.desktop || 4,
          },
          1200: {
            slidesPerView: configuration.breakpoints?.large || 5,
          }
        }
      });
    } catch (error) {
      console.error('Error initializing Swiper carousel:', error);
    }
  }
}
